
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_1a743_fs1jr_5",
  "variant-normal": "awsui_variant-normal_1a743_fs1jr_5",
  "pressed": "awsui_pressed_1a743_fs1jr_14",
  "variant-icon": "awsui_variant-icon_1a743_fs1jr_20"
};
  